import { Text } from '@mxenabled/mxui'

import Stack from '@mui/material/Stack'
import { useTheme } from '@mui/material/styles'
import { type SxProps } from '@mui/material/styles'

export interface LegendV2Props {
  color: string
  legendStyle?: SxProps
  monthlyAmount?: string
  monthlyAmountLabel?: string
  trendAmount?: string
  trendAmountLabel?: string
}

export const LegendV2 = ({
  color,
  legendStyle = {},
  monthlyAmount,
  monthlyAmountLabel,
  trendAmount,
  trendAmountLabel,
}: LegendV2Props) => {
  const theme = useTheme()

  return (
    <Stack
      sx={{
        alignItems: 'center',
        flexDirection: 'row',
        gap: 24,
        justifyContent: 'flex-start',
        py: 4,
        width: '100%',
        ...legendStyle,
      }}
    >
      {monthlyAmountLabel && (
        <Stack sx={{ alignItems: 'center', flexDirection: 'row', gap: 8 }}>
          <svg
            aria-hidden="true"
            aria-labelledby="chartLegendLabel"
            fill="none"
            height="12"
            role="figure"
            width="12"
          >
            <rect fill={color} height="12" rx="2" width="12" />
          </svg>
          <Text id="chartLegendLabel" variant="caption">
            {monthlyAmountLabel}: {monthlyAmount}
          </Text>
        </Stack>
      )}

      {trendAmountLabel && (
        <Stack sx={{ alignItems: 'center', flexDirection: 'row', gap: 8 }}>
          <svg
            aria-hidden="true"
            aria-labelledby="chartLegendLabel"
            fill="none"
            height="12"
            role="figure"
            width="12"
          >
            <rect fill={theme.palette.chart.chart7} height="12" rx="2" width="12" />
          </svg>
          <Text id="chartLegendLabel" variant="caption">
            {trendAmountLabel}: {trendAmount}
          </Text>
        </Stack>
      )}
    </Stack>
  )
}
